import { Typography } from '@mui/material';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import React, { FC } from 'react';
import { Link as RouterLink, LinkProps as RouterLinkProps, useMatch } from 'react-router-dom';

import { useAppRoot } from '../routerTabs/routerTabs.hook';

interface ListLinkProps {
  linkProps: RouterLinkProps;
  icon: React.ReactNode;
  label: string;
}

export const ListLink: FC<ListLinkProps> = ({ label, icon, linkProps }) => {
  const appRoot = useAppRoot();
  // Construct an absolute path to avoid v7_relativeSplatPath issues
  const absoluteTo =
    typeof linkProps.to === 'string' && !linkProps.to.startsWith('/')
      ? `${appRoot}/${linkProps.to}`
      : linkProps.to;

  const match = useMatch(`${absoluteTo}/*`);

  return (
    <ListItemButton selected={Boolean(match)} component={RouterLink} to={absoluteTo}>
      <ListItemIcon>{icon}</ListItemIcon>
      <ListItemText
        primary={
          <Typography
            variant="inherit"
            sx={{
              color: 'text.primary',
            }}
          >
            {label}
          </Typography>
        }
      />
    </ListItemButton>
  );
};
